import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import ur from "./locales/ur.json";
import hi from "./locales/hi.json";
import pa from "./locales/pa.json";

// To add a new language later:
//   1. Drop a matching JSON file into ./locales/<code>.json
//   2. Add it below in resources + LANGUAGES
//   3. If it's right-to-left, add its code to RTL_LANGUAGES
export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "fr", label: "French", native: "Français" },
  { code: "es", label: "Spanish", native: "Español" },
  { code: "ar", label: "Arabic", native: "العربية" },
  { code: "ur", label: "Urdu", native: "اردو" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "pa", label: "Punjabi", native: "ਪੰਜਾਬੀ" },
];

export const RTL_LANGUAGES = new Set(["ar", "ur"]);

export const isRTL = (code) => RTL_LANGUAGES.has(code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      ar: { translation: ar },
      ur: { translation: ur },
      hi: { translation: hi },
      pa: { translation: pa },
    },
    fallbackLng: "en",
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "hm_lang",
    },
  });

const applyDirection = (lng) => {
  if (typeof document === "undefined") return;
  const code = (lng || "en").split("-")[0];
  document.documentElement.setAttribute("lang", code);
  document.documentElement.setAttribute("dir", isRTL(code) ? "rtl" : "ltr");
};

applyDirection(i18n.language);
i18n.on("languageChanged", applyDirection);

export default i18n;
